import Students from "./Students";
import {
  StudentLimitedResponse,
  ParentLimitedResponse,
  Auth0AccountRole,
} from "client/openapi";
import MeetingHistory from "./Meetings";
import AdministrativeInfo from "pages/manage/students/[id]/StudentInfoTab/AdministrativeInfo";
import { useContext, useState } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";
import PersonFormsSection from "components/Forms/PersonFormsSection";
import PersonTasksSection from "components/Tasks/PersonTasksSection";

export default function ParentInfoTab({
  parent,
  orgStudents,
  parentStudents,
  setParentStudents,
  exportingMeetings,
  setExportingMeetings,
  setStatus,
  setError,
}: {
  parent: ParentLimitedResponse;
  orgStudents: StudentLimitedResponse[];
  parentStudents: StudentLimitedResponse[];
  setParentStudents: (students: StudentLimitedResponse[]) => void;
  exportingMeetings: boolean;
  setExportingMeetings: (boolean) => void;
  setStatus: (PageStatus) => void;
  setError: (APIResponse) => void;
}) {
  const [exportingData, setExportingData] = useState<boolean>(false);
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);

  return (
    <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-3">
      <div className="flex">
        <AdministrativeInfo
          exportingData={exportingData}
          setExportingData={setExportingData}
          userType={Auth0AccountRole.PARENT}
          parent={parent}
          organization_id={parent.org_id}
          exportingMeetings={exportingMeetings}
          setStatus={setStatus}
          setError={setError}
        />
      </div>

      <div className="flex flex-col gap-5">
        <Students
          parent={parent}
          orgStudents={orgStudents}
          parentStudents={parentStudents}
          setParentStudents={setParentStudents}
        />
        <PersonTasksSection
          orgId={parent.org_id}
          personType={Auth0AccountRole.PARENT}
          personId={parent.id}
        />
        {currently_selected_role === Auth0AccountRole.ORG_ADMIN && (
          <PersonFormsSection
            orgId={parent.org_id}
            personType={Auth0AccountRole.PARENT}
            personId={parent.id}
          />
        )}
      </div>

      <div className="flex">
        <MeetingHistory
          exportingMeetings={exportingMeetings}
          setExportingMeetings={setExportingMeetings}
          parent={parent}
          setStatus={setStatus}
          setError={setError}
        />
      </div>
    </div>
  );
}
